import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import { numberFormatter } from '../../../../utils/number';
import { tzNormalizeDate } from '../../../../utils/date';
import EnumStatus from '../../../common/EnumStatus';
import { MIGRATION_STATUS } from '../../../../config/constants';
import { DATE_FORMAT } from '../../../../config/locale';
import { EXPENSE_PATH } from '../../../../config/paths';
import LinkToModuleResource from '../../../common/resource/LinkToModuleResource';

const DetailField = ({ label, value }) => (
  <Row className="mb-2">
    <Col xs={5}>
      <strong>{label}</strong>
    </Col>
    <Col xs={7}>{value || '-'}</Col>
  </Row>
);

DetailField.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.node,
};

DetailField.defaultProps = {
  value: null,
};

const ExpenseSapMigrationDetailView = ({ expenseSapMigration }) => {
  const {
    expenseId,
    agency,
    costCenter,
    expenseTypeName,
    issueDate,
    voucherType,
    documentSeries,
    documentCode,
    businessTaxId,
    businessName,
    description,
    totalAmount,
    sysCode,
    accountCode,
    accountName,
    companyBusId,
    driversInfo,
    migrationStatus,
  } = expenseSapMigration;

  const accountDisplay =
    accountCode && accountName
      ? `${accountCode} - ${accountName}`
      : sysCode || '-';

  return (
    <div>
      <DetailField
        label="Egreso"
        value={
          expenseId ? (
            <LinkToModuleResource
              text={`${expenseId}`}
              href={`${EXPENSE_PATH}/${expenseId}`}
              isExternalPath
            />
          ) : null
        }
      />
      <DetailField
        label="Nombre Socio de Negocio"
        value={agency ? agency.name : null}
      />
      <DetailField
        label="Centro de Costo"
        value={costCenter ? `${costCenter.costCenterCode} - ${costCenter.name}` : null}
      />
      <DetailField label="Tipo de Egreso" value={expenseTypeName} />
      <DetailField
        label="Fecha de Emisión"
        value={
          issueDate
            ? tzNormalizeDate({ date: issueDate, format: DATE_FORMAT })
            : null
        }
      />
      <DetailField
        label="Tipo de Comprobante"
        value={voucherType ? `${voucherType.voucherCode} - ${voucherType.name}` : null}
      />
      <DetailField label="Serie" value={documentSeries} />
      <DetailField label="Correlativo" value={documentCode} />
      <DetailField label="RUC Proveedor" value={businessTaxId} />
      <DetailField label="Nombre Proveedor" value={businessName} />
      <DetailField label="Descripción" value={description} />
      <DetailField
        label="Importe Total"
        value={totalAmount ? numberFormatter({ value: totalAmount }) : null}
      />
      <DetailField label="Cuenta Contable" value={accountDisplay} />
      <DetailField label="Bus" value={companyBusId} />
      <DetailField label="Conductores" value={driversInfo} />
      <DetailField
        label="Estado"
        value={
          <EnumStatus
            enumObject={MIGRATION_STATUS}
            enumValue={migrationStatus}
          />
        }
      />
    </div>
  );
};

ExpenseSapMigrationDetailView.propTypes = {
  expenseSapMigration: PropTypes.shape({
    expenseId: PropTypes.string,
    agency: PropTypes.shape({ name: PropTypes.string }),
    costCenter: PropTypes.shape({ name: PropTypes.string, costCenterCode: PropTypes.number }),
    expenseTypeName: PropTypes.string,
    issueDate: PropTypes.string,
    voucherType: PropTypes.shape({ voucherCode: PropTypes.string, name: PropTypes.string }),
    documentSeries: PropTypes.string,
    documentCode: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    businessTaxId: PropTypes.string,
    businessName: PropTypes.string,
    description: PropTypes.string,
    totalAmount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    sysCode: PropTypes.string,
    accountCode: PropTypes.string,
    accountName: PropTypes.string,
    companyBusId: PropTypes.string,
    driversInfo: PropTypes.string,
    migrationStatus: PropTypes.string,
  }).isRequired,
};

export default ExpenseSapMigrationDetailView;
